import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-purchase-menu',
    templateUrl: './purchase-menu.component.html',
    styleUrls: ['./purchase-menu.component.css'],
})
export class PurchaseMenuComponent {
    /**
     * The name of the purchase webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
